import React from "react";
import SlideOverlay from "./SlideOverlay";
import CubeCodeScene from "../CubeCodeScene";

const SlideDevTools = React.memo(function SlideDevTools() {
  return (
    <>
      {/* Background Layer — Isometric CubeCode Scene */}
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: "#04040e",
          willChange: "transform",
          contain: "layout style paint",
        }}
      >
        <CubeCodeScene />
      </div>

      {/* Bottom vignette — outside the 3D context so it renders on top */}
      <div
        className="absolute inset-0 pointer-events-none z-10"
        style={{
          background: "linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.5) 100%)",
        }}
      />

      <SlideOverlay
        label="Build Faster, Ship Smarter"
        title="Developer Velocity"
        description="From prototype to production AI in minutes — typed SDKs, instant sandboxes, and one-click deployment pipelines designed for teams that ship"
        ctaText="Explore Dev Tools"
        ctaUrl="/products/neural-sdk"
      />
    </>
  );
});

export default SlideDevTools;
